/**
 * La cantidad que se escribe en una linea del pedido (CARRITO-UX-P1-T1; WORK-CARRITO-UX-REFERENCIAS, P1 "cantidad
 * invalida no se convierte silenciosamente").
 *
 * Antes: parseInt(valor) || 0 y 0 quitaba la linea. Escribir "dos", borrar el numero o poner "1,5" BORRABA el
 * producto del pedido sin avisar. Ahora:
 *   "3"            -> 3
 *   "0"            -> 0 (decision explicita: quitar la linea)
 *   "", "dos", "1,5", "-2" -> se conserva la cantidad anterior y se dice por que
 *
 * @module application/carrito/cantidadDeLinea
 */

export const AVISO_CANTIDAD = 'Escribe una cantidad entera (1 o mas). Para quitarlo, pon 0 o toca la X.';

/** @returns {{ qty: number, error: string }} */
export function interpretarCantidad(texto, anterior) {
  const t = String(texto ?? '').trim();
  if (/^\d+$/.test(t)) return { qty: Number(t), error: '' };
  return { qty: anterior, error: AVISO_CANTIDAD };
}
